var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('factory-order-list',{ref:"orderList",attrs:{"height":this.$tools.mainHeight() - 131,"rights":"'d,f,h'","pageUrl":'factory/order/progressPage',"isRoot":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }